module.exports = __webpack_public_path__ + "img/delete.c77e5e69.svg";